import type { Validator } from '../Validator'
import { validateCompleteError, validateCompleteSuccess } from '../Validator'

export const regexValidator = (
    options: Validator.options & { regex: RegExp }
): Validator.validatorSingle<number | string | undefined, unknown> => ({
    isAsync: false,
    validate: value => {
        if (value === undefined || '' === value) {
            return validateCompleteSuccess()
        }

        if (options.regex.test(value.toString())) {
            return validateCompleteSuccess()
        }

        return validateCompleteError(options, 'Formato non valido')
    },
})
